import { composeIO } from 'react-compose-io'
import { modalConfirmarIO } from './ModalConfirmar.IO'
import { ModalConfirmarView } from './ModalConfirmar.View'

export const ModalConfirmar = composeIO(ModalConfirmarView, modalConfirmarIO)
